module.exports = __webpack_public_path__ + "static/background-8cc5ac90e933cba62e7372e62f6d0459.png";